<div *ngIf="!showRequest">
  <h2 *ngIf="isShow" class="sectionTitle">{{'FRONT_USER.MEASUREMNT_OFFICER_FORM.MEASUREMNT_OFFICER' | translate }}</h2>

  <div *ngIf="baseRequestId" class="read-only-content">
    <!--request Details summary-->
    <app-fees-estimation-request [IsAdminMode]="true" [AgentId]="agentId"></app-fees-estimation-request>
  </div>

  <div *ngIf="baseRequestId">

    <form #measurementRequest [formGroup]="measurementOfficerForm">
      <div class="form-container">
        <div class="form-section">
          <h4 class="section-title">{{'FRONT_USER.FEES_ESTIMATION_FORM.FEES'| translate}}</h4>

          <div class="form-group">
            <label for="Currency">{{'FRONT_USER.FEES_ESTIMATION_FORM.PAYMENT_CURRENCY' | translate}}</label>
            <input type="text" formControlName="Currency" class="form-control" />
          </div>

          <div class="form-group">
            <label for="FeeValue">{{ 'FRONT_USER.MEASUREMNT_OFFICER_FORM.FEES_VALUE' | translate}}</label>
            <span class="red">*</span>
            <input type="text" formControlName="FeeValue" id="FeeValue" name="FeeValue" class="form-control" />
            <div *ngIf="submitted || (f.FeeValue?.dirty &&f.FeeValue?.errors)" class="red">
              <div *ngIf="f.FeeValue?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
              <div *ngIf="f.FeeValue?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
              <!-- <div *ngIf="f.FeeValue?.errors?.startsWithSpaceError">
                {{'FRONT_USER.START_WITH_SPACE' | translate}}
              </div> -->
            </div>
          </div>

          <div class="form-group">
            <label for="InsuranceValue">{{ 'FRONT_USER.MEASUREMNT_OFFICER_FORM.INSURANCE_VALUE' | translate}}</label>
            <input type="text" formControlName="InsuranceValue" id="InsuranceValue" name="InsuranceValue"
              class="form-control" />
            <div *ngIf="submitted || (f.InsuranceValue?.dirty &&f.InsuranceValue?.errors)" class="red">
              <!-- <div *ngIf="f.InsuranceValue?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div> -->
              <div *ngIf="f.InsuranceValue?.errors?.pattern">
                {{'FRONT_USER.NUMBER_ERROR' | translate}}
              </div>
            </div>
          </div>



          <div class="form-group">
            <label
              for="MeasurementDescription">{{'FRONT_USER.MEASUREMNT_OFFICER_FORM.MEASUREMNT_REQUIREMENTS' | translate}}</label>

            <textarea formControlName="MeasurementDescription" id="MeasurementDescription" name="MeasurementDescription"
              class="form-control"></textarea>
          </div>
        </div>


        <div *ngIf="formMode == FormMode.Add" class="form-section">
          <h4 class="section-title">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.MEASUREMENT_DECISION'| translate}}</h4>

          <div class="form-group">
            <span class="red">*</span>
            <label for="Decision">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.DECISION' | translate}}</label>
            <div class="form-custom-inputs">

              <div *ngFor="let decisions of decisionKeys;let i='index'" class=" custom-Radio">
                <input type="radio" [id]=[decisions]  name="Decision"  [value]="decision[decisions]"
                  formControlName="Decision" />

                <label [for]="[decisions]">{{ 'FRONT_USER.ADMIN_DECISION_FORM.' + decisions | translate }}</label>

              </div>
            </div>
            <div *ngIf="submitted && f.Decision?.errors" class="red">
              <div *ngIf="f.Decision?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>

            </div>
          </div>
        </div>
        <div *ngIf="formMode == FormMode.Add" class="form-group">
          <button Confirmation (confirmationClick)="onSubmit()"
            class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SUBMIT' | translate}}</button>
        </div>
      </div>
    </form>

    <br>

  </div>
</div>

<!-- Confirmation -->
<div *ngIf="showRequest && !isErrorMessage  && !lockTaskErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.TAKE_DECISION_SUCCESS_MESSAGE' | translate }}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>

  </div>
</div>

<!-- error message -->
<div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>

    <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
    <hr>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
        {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

<div *ngIf="showRequest && lockTaskErrorMessage" class="alert alert-warning" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>
        <hr>
        <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
          {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
      </div>
  </div>